import { render, staticRenderFns } from "./PeerGroupRoleInfo.vue?vue&type=template&id=1588c966&"
import script from "./PeerGroupRoleInfo.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupRoleInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PeerGroupRoleInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports